import type { AxiosResponse } from 'axios';
import { $api } from '../axios/axios';
import { RolesValues } from '@constants';

export default class RolesService {
  static async rolePermissionAssign(body: { roleName: RolesValues; employeeId: number }): Promise<AxiosResponse> {
    return $api.post('/recruiting-tool/api/v1/role-permission/assign', { ...body });
  }
}
